{
    "Accessibility Menu": "תפריט נגישות",
    "Reset settings": "איפוס הגדרות",
    "Close": "סגור",
    "Content Adjustments": "התאמות תוכן",
    "Adjust Font Size": "התאם גודל פונט",
    "Highlight Title": "הדגש כותרת",
    "Highlight Links": "הדגש קישורים",
    "Readable Font": "פונט קריא",
    "Color Adjustments": "התאמות צבע",
    "Dark Contrast": "ניגודיות כהה",
    "Light Contrast": "ניגודיות בהירה",
    "High Contrast": "ניגודיות גבוהה",
    "High Saturation": "רווי צבע גבוה",
    "Low Saturation": "רווי צבע נמוך",
    "Monochrome": "מונוכרום",
    "Tools": "כלים",
    "Reading Guide": "מדריך קריאה",
    "Stop Animations": "עצירת אנימציות",
    "Big Cursor": "סמן גדול",
    "Increase Font Size": "הגדל גודל פונט",
    "Decrease Font Size": "הקטן גודל פונט",
    "Letter Spacing": "מרווח בין אותיות",
    "Line Height": "גובה שורה",
    "Font Weight": "משקל הפונט",
    "Dyslexia Font": "פונט לדיסלקטים",
    "Language": "שפה",
    "Open Accessibility Menu": "פתח תפריט נגישות"
}